export default {
  path: "/auth",
  name: process.env.VUE_APP_AUTH_LAYOUT,
  component: () => import("@/pages/auth/Index.vue"),
  children: [
    {
      path: "/auth/login",
      name: process.env.VUE_APP_AUTH_LOGIN,
      component: () => import("@/pages/auth/Login.vue"),
      meta: {
        anon_only: true,
      },
    },
    {
      path: "/auth/register",
      name: process.env.VUE_APP_AUTH_REGISTER_STEP_1,
      component: () => import("@/pages/auth/Register.vue"),
      meta: {
        anon_only: true,
      },
    },
    {
      path: "/auth/register/step2",
      name: process.env.VUE_APP_AUTH_REGISTER_STEP_2,
      component: () => import("@/pages/auth/EmailPassword.vue"),
      meta: {
        anon_only: true,
      },
    },
    {
      path: "/auth/register/verify/password",
      name: process.env.VUE_APP_AUTH_VERIFY_PASSWORD,
      component: () => import("@/pages/auth/VerifyPassword.vue"),
      meta: {
        anon_only: true,
      },
    },
    {
      path: "/forget/password",
      name: process.env.VUE_APP_AUTH_FORGET_PASSWORD,
      component: () => import("@/pages/auth/ForgetPassword.vue"),
      meta: {
        anon_only: true,
      },
    },
    {
      path: "/auth/reset/password",
      name: process.env.VUE_APP_AUTH_RESET_PASSWORD,
      component: () => import("@/pages/auth/ResetPassword.vue"),
      meta: {
        guest: true,
      },
    },
    {
      path: "/auth/logout",
      name: process.env.VUE_APP_AUTH_LOGOUT,
      component: () => import("@/pages/auth/Logout.vue"),
      meta: {
        anon_only: false,
      },
    },
  ],
}
